<template>
    <div class="view view-challenge-list">
        <HeaderChallengeList
            textH1="Meydan Okuma Listesi"
            textDesc="Tüm meydan okumalarına göz at."/>
        <FilterbarChallengeList />
        <Preloader
            v-if="showPreloader"
            preloaderText="Yükleniyor..." />
        <CardEmptyStateChallengeList
            v-if="showEmptyState"
            textHeading="Meydan Okuma Yok"
            :textDesc="emptyStateDesc" />
        <div
            v-if="showChallengeList"
            class="view-challenge-list__wr-list">
            <div
                class="challenge-list-date-group"
                v-for="dateGroup in filteredListItems" :key="dateGroup.date">
                <div class="challenge-list-date-group__date">
                    <span class="challenge-list-date-group__date-text">{{ getFormattedDate(dateGroup.date) }}</span>
                    <span class="challenge-list-date-group__date-separator"></span>
                </div>
                <template v-for="challengeItem in dateGroup.items" :key="challengeItem.id">
                    <CardChallengeListItemCompleted
                        v-if="challengeItem.status === 'COMPLETED'"
                        :challengeItem="challengeItem" />
                    <CardChallengeListItemIncomplete
                        v-if="challengeItem.status !== 'COMPLETED'"
                        :challengeItem="challengeItem" />
                </template>
            </div>
        </div>

        <BtnChallenge
            @click="routeChallengeSelectUser"/>
        <BtnPracticeModes
            @click="routePracticeModes" />
        <Navbar />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallengeList              from '@/components/HeaderChallengeList.vue';
    import FilterbarChallengeList           from '@/components/FilterbarChallengeList.vue';
    import Preloader                        from '@/components/Preloader.vue';
    import CardEmptyStateChallengeList      from '@/components/CardEmptyStateChallengeList.vue';
    import CardChallengeListItemCompleted   from '@/components/CardChallengeListItemCompleted.vue'
    import CardChallengeListItemIncomplete  from '@/components/CardChallengeListItemIncomplete.vue';
    import BtnChallenge                     from '@/components/BtnChallenge.vue';
    import BtnPracticeModes                 from '@/components/BtnPracticeModes.vue';
    import Navbar                           from '@/components/Navbar.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                Library Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import moment from 'moment';

    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallengeList,
            FilterbarChallengeList,
            Preloader,
            CardEmptyStateChallengeList,
            CardChallengeListItemCompleted,
            CardChallengeListItemIncomplete,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        data(){
            return {
                showPreloader: true,
                listItems: []
            };
        },

        computed: {
            showEmptyState(){
                if(this.showPreloader){
                    return false;
                }
                else if(this.filteredListItems.length === 0){
                    return true;
                }
                return false;
            },

            showChallengeList(){
                if(this.showPreloader){
                    return false;
                }
                else if(this.showEmptyState){
                    return false;
                }
                return true;
            },

            filteredListItems(){
                let filteredListItems = [];
                let selectedFiltertag = this.$store.state.selectedFiltertagChallengeList;

                if(selectedFiltertag.type === 'all'){
                    return this.listItems.filter(item => true);
                }
                else if(selectedFiltertag.type === 'ongoing'){
                    this.listItems.forEach(dateGroup => {
                        let filteredItems = dateGroup.items.filter(item => item.status === 'ONGOING');
                        if(filteredItems.length > 0){
                            let newDateGroup = {
                                date: dateGroup.date,
                                items: filteredItems,
                            };
                            filteredListItems.push(newDateGroup);
                        }
                    });
                    return filteredListItems;
                }
                else if(selectedFiltertag.type === 'completed'){
                    this.listItems.forEach(dateGroup => {
                        let filteredItems = dateGroup.items.filter(item => item.status === 'COMPLETED');
                        if(filteredItems.length > 0){
                            let newDateGroup = {
                                date: dateGroup.date,
                                items: filteredItems,
                            };
                            filteredListItems.push(newDateGroup);
                        }
                    });
                    return filteredListItems;
                }
                else if(selectedFiltertag.type === 'cancelled'){
                    this.listItems.forEach(dateGroup => {
                        let filteredItems = dateGroup.items.filter(item => item.status === 'CANCELLED');
                        if(filteredItems.length > 0){
                            let newDateGroup = {
                                date: dateGroup.date,
                                items: filteredItems,
                            };
                            filteredListItems.push(newDateGroup);
                        }
                    });
                    return filteredListItems;
                }
                else{
                    console.error("VIEW_CHALLENGE_LIST/COMPUTED/FILTERED_LIST_ITEMS::INV_FILTERTAG_TYPE");
                    this.$foneturkError({text: 'Bir şeyler ters gitti.'});
                    return [];
                }
            },

            emptyStateDesc(){
                let selectedFiltertag = this.$store.state.selectedFiltertagChallengeList;

                if(selectedFiltertag.type === 'all'){return 'Hiç meydan okuman olmamış.'; }
                else if(selectedFiltertag.type === 'ongoing'){ return 'Devam eden meydan okuma yok.'; }
                else if(selectedFiltertag.type === 'completed'){ return 'Tamamlanmış meydan okuma yok.'; }
                else if(selectedFiltertag.type === 'cancelled'){ return 'İptal olmuş meydan okuma yok.'; }
            }
        },

        methods: {
            getFormattedDate(date){
                return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY').toLocaleUpperCase('tr-TR');
            },

            routeChallengeSelectUser(){
                this.$router.push('/challenge/select-user');
            },

            routePracticeModes(){
                this.$router.push('/practice-modes');
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.challengeListAll)
                .then(response => {
                    return response.json();
                })
                .then(listItems => {
                    if(listItems.length > 0){
                        this.listItems = listItems;
                        this.showPreloader = false;
                    }
                });
            }
            else{
                fetch(this.$store.state.api.challengeListAll, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(challengeItems => {
                    this.listItems = challengeItems;
                    this.showPreloader = false;
                });
            }
        }
    };
</script>

<style scoped src="@/css/views/view-challenge-list.css"></style>